import { DataCache, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { ReservationsDashboardRow } from 'data/models/ReservationsDashboardRow';

export class ReservationsListBaseCache extends DataCache {
    ReservationsDashboardRows = PCCollection(ReservationsDashboardRow);

    constructor(data : PCCache) {
        super();

        new SharedKeyRelationship(this.ReservationsDashboardRows, data.BerthReservations, row => row.Reservation, null);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/reservationslistbase/cache.ts